import { cx } from '@otter-ai/den-components';
import { ChevronRightIcon } from '@otter-ai/den-icons';
import type { ReactNode } from 'react';

export type AppRowSettingDetailsProps = {
  title: ReactNode;
  description: ReactNode;
  actionText: string;
  onClick: () => void;
  'data-testid': string;
  isError?: boolean;
};

export function AppRowSettingDetails({
  title,
  description,
  actionText,
  onClick,
  'data-testid': testId,
  isError = false,
}: AppRowSettingDetailsProps) {
  return (
    <button
      data-testid={testId}
      className={cx(
        'rounded-lg p-4 pr-1',
        isError ? 'bg-palette-yellow-300' : 'bg-secondary',
        isError ? 'text-palette-yellow-950' : 'text-subtle',
        isError
          ? 'hover:bg-palette-yellow-200 focus:bg-palette-yellow-200'
          : 'hover:bg-secondary-hover focus:bg-secondary-hover',
        'flex flex-row justify-between gap-4 w-full',
        'text-left text-sm',
      )}
      onClick={onClick}
    >
      <div className="flex flex-col gap-1 self-start justify-start">
        <div className="text-sm font-semibold text-palette-blue-950">
          {title}
        </div>
        <div className="text-sm text-secondary-foreground">{description}</div>
      </div>
      <div className="flex items-center self-center gap-0 text-xs font-semibold">
        {actionText} <ChevronRightIcon />
      </div>
    </button>
  );
}
